export default class ApplicationException {
}
